import React, { useState } from 'react';
import { Segment, Checkbox, Dropdown } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { some, forEach } from 'lodash';
import classnames from 'classnames';
import TravelInsurancesTable from '../InsuranceTables/TravelInsurancesTable';
import DraftTravelInsurancesTable from '../InsuranceTables/DraftTravelInsurancesTable';
import CMTPLInsurancesTable from '../InsuranceTables/CMTPLInsurancesTable';
import styles from './InsuranceLists.module.scss';
import VMTPLInsurancesTable from '../InsuranceTables/VMTPLInsurancesTable';
import PropertyInsurancesTable from '../InsuranceTables/PropertyInsurancesTable';
import DraftPropertyInsurancesTable from '../InsuranceTables/DraftPropertyInsurancesTable';
import CMTPLCascoInsurancesTable from '../InsuranceTables/CMTPLCascoInsurancesTable';

const InsuranceLists = () => {
  const { t } = useTranslation();
  const [checkboxesState, updateCheckboxesState] = useState({
    travel: true,
    property: true,
    cmtpl: true,
    cmtplCasco: true,
    vmtpl: true,
  });
  const checkOption = (value, option) => {
    updateCheckboxesState({ ...checkboxesState, [option]: value });
  };
  const allChecked = () => !some(checkboxesState, (c) => !c);
  const indeterminate = () => some(checkboxesState, (c) => c) && some(checkboxesState, (c) => !c);
  const nothingChecked = () => !some(checkboxesState, (c) => c);
  const getDropdownValue = () => {
    const keys = Object.keys(checkboxesState);
    return keys.filter((key) => checkboxesState[key]);
  };

  const handleDropDownChange = (options, { value }) => {
    const newCheckBoxState = {
      travel: false,
      property: false,
      cmtpl: false,
      cmtplCasco: false,
      vmtpl: false,
    };
    forEach(value, (option) => {
      newCheckBoxState[option] = true;
    });
    updateCheckboxesState(newCheckBoxState);
  };
  const toggleSelectAll = () => {
    if (allChecked() || indeterminate()) {
      updateCheckboxesState({
        travel: false,
        property: false,
        cmtpl: false,
        cmtplCasco: false,
        vmtpl: false });
    } else {
      updateCheckboxesState({
        travel: true,
        property: true,
        cmtpl: true,
        cmtplCasco: false,
        vmtpl: true });
    }
  };

  return (
    <div id={styles.insurancesList}>

      <div className={classnames(styles.insListHeader, styles.mobileContent)}>
        {t('headerTitles.myContracts')}
      </div>

      <div className={styles.pageContent}>
        <div className={styles.dropdownSection}>
          <Dropdown
            fluid
            selection
            multiple
            placeholder={t('insuranceList.types')}
            value={getDropdownValue()}
            options={Object.keys(checkboxesState).map((k) => ({ value: k, text: t(`insuranceList.${k}`), key: k }))}
            onChange={handleDropDownChange}
            className={styles.dropdown}
          />
        </div>
        <div className={styles.checkboxSection}>
          <div className={styles.checkboxText}>{t('insuranceList.types')}</div>
          <div className={styles.checkboxContainer}>
            <Checkbox
              label={t('insuranceList.all')}
              checked={allChecked()}
              indeterminate={indeterminate()}
              onChange={toggleSelectAll}
            />
          </div>
          {Object.keys(checkboxesState).map((keyName) => (
            <div className={styles.checkboxContainer} key={keyName}>
              <Checkbox
                label={t(`insuranceList.${keyName}`)}
                checked={checkboxesState[keyName]}
                onChange={(e, { checked }) => {
                  checkOption(checked, keyName);
                }}
              />
            </div>
          ))}
        </div>
        <div className={styles.tableSection}>
          <div className={classnames(checkboxesState.travel ? null : styles.hidden)}>
            <TravelInsurancesTable />
            <DraftTravelInsurancesTable />
          </div>
          <div className={classnames(checkboxesState.property ? null : styles.hidden)}>
            <PropertyInsurancesTable />
            <DraftPropertyInsurancesTable />
          </div>
          <div className={classnames(checkboxesState.cmtpl ? null : styles.hidden)}>
            <CMTPLInsurancesTable />
          </div>
          <div className={classnames(checkboxesState.cmtplCasco ? null : styles.hidden)}>
            <CMTPLCascoInsurancesTable />
          </div>
          <div className={classnames(checkboxesState.vmtpl ? null : styles.hidden)}>
            <VMTPLInsurancesTable />
          </div>
          {nothingChecked()
            && <Segment className={styles.emptySelect}>{t('insuranceList.noSelectedContract')}</Segment>}
        </div>
      </div>
    </div>
  );
};

export default InsuranceLists;
